import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button, Input, Label, FormGroup, } from "reactstrap";
import { toast } from "react-toastify";

import useLeadSync from "../../Hooks/useLeadSync";

const LeadSyncSettingsModal = ({ isOpen, toggle, }) => {

  const { settings, updateSettings, } = useLeadSync();

  const [formData, setFormData] = useState({
    status: false,
    duration: 5,
    durationType: "minutes",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    if (settings) {

      setFormData({
        status: settings.status || false,
        duration: settings.duration || 5,
        durationType:
          settings.durationType || "minutes",
      });
    }

  }, [settings]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const res = await updateSettings(
        formData
      );
      if (!res.status == 200) {
        return toast.error(res.message);
      }

      toast.success(res?.message || "Lead Sync Settings Updated");

      toggle();

    } catch (err) {

      toast.error(err?.response?.data?.error || err?.message || "Failed to update settings");
    } finally {

      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>
        Lead Sync Settings
      </ModalHeader>

      <ModalBody>

        <div className="d-flex align-items-center mb-3">
          <input
            id="leadSyncSwitch"
            type="checkbox"
            switch="primary"
            checked={formData.status}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                status: e.target.checked,
              }))
            }
          />
          <label
            htmlFor="leadSyncSwitch"
            data-on-label=""
            data-off-label=""
            className="mb-0"
          />
          <span className="ms-2 fw-semibold">
            Enable Lead Sync
          </span>
        </div>

        <FormGroup className="mt-3">
          <Label>
            Sync Duration
          </Label>

          <Input
            type="number"
            min={1}
            value={formData.duration}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                duration: e.target.value,
              }))
            }
          />
        </FormGroup>

        <FormGroup className="mt-3">
          <Label>
            Duration Type
          </Label>

          <Input
            type="select"
            value={formData.durationType}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                durationType: e.target.value,
              }))
            }
          >
            <option value="seconds">
              Seconds
            </option>

            <option value="minutes">
              Minutes
            </option>

            <option value="hours">
              Hours
            </option>
          </Input>
        </FormGroup>

        <div className="text-end mt-4">
          <Button
            color="primary"
            disabled={loading}
            onClick={handleSubmit}
          >
            {
              loading
                ? "Saving..."
                : "Save Settings"
            }
          </Button>
        </div>

      </ModalBody>
    </Modal>
  );
};

export default LeadSyncSettingsModal;